import { createSingleton } from '../SingletonFactory';
import { AnthropicAI } from './AnthropicAI';
import { OpenAIAI } from './OpenAIAI';
import { TextToImageAI } from './TextToImageAI';
import { TextToVideoAI } from './TextToVideoAI';
import { ImageTo3DAI } from './ImageTo3DAI';
import { RecraftAI } from './RecraftAI';
import { ImageToImageAI } from './ImageToImageAI';
import { GeminiAI } from './GeminiAI';
import { UnifiedLLM } from './UnifiedInstructor';

class AIServices {
  private anthropicAI: AnthropicAI;
  private openaiAI: OpenAIAI;
  private textToImageAI: TextToImageAI;
  private textToVideoAI: TextToVideoAI;
  private imageTo3DAI: ImageTo3DAI;
  private imageToImageAI: ImageToImageAI;
  private recraftAI: RecraftAI;
  private geminiAI: GeminiAI;
  private unifiedLlm: UnifiedLLM;

  constructor() {
    this.anthropicAI = new AnthropicAI();
    this.openaiAI = new OpenAIAI();
    this.textToImageAI = new TextToImageAI();
    this.textToVideoAI = new TextToVideoAI();
    this.imageTo3DAI = new ImageTo3DAI();
    this.imageToImageAI = new ImageToImageAI();
    this.recraftAI = new RecraftAI();
    this.geminiAI = new GeminiAI();
    this.unifiedLlm = new UnifiedLLM();
  }

  getUnifiedLLM(): UnifiedLLM {
    return this.unifiedLlm;
  }

  getGeminiAI(): GeminiAI {
    return this.geminiAI;
  }
  getAnthropicAI(): AnthropicAI {
    return this.anthropicAI;
  }

  getOpenAIAI(): OpenAIAI {
    return this.openaiAI;
  }

  getTextToImageAI(): TextToImageAI {
    return this.textToImageAI;
  }

  getTextToVideoAI(): TextToVideoAI {
    return this.textToVideoAI;
  }

  getImageTo3DAI(): ImageTo3DAI {
    return this.imageTo3DAI;
  }

  getImageToImageAI(): ImageToImageAI {
    return this.imageToImageAI;
  }

  getRecraftAI(): RecraftAI {
    return this.recraftAI;
  }
}

export default createSingleton(AIServices);
